import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpBadge } from 'Wpds/components/badge';

// Styles
import './SourceWrapper.scss';

type Props = {
  logo: string;
  name: string;
  connected?: boolean;
  selected?: boolean;
  onClick: Function;
  connectedMsg?: string;
  selectMessage?: string;
};
const SourceWrapper = ({
  logo,
  name,
  selected,
  connected,
  onClick,
  connectedMsg = 'connected',
  selectMessage = 'Select',
}: Props) => {
  const baseClassName = 'SourceWrapper';

  return (
    <WpContainer className={baseClassName} onClick={onClick}>
      <WpContainerBody padding="05" className={`${baseClassName}__body`}>
        <img src={logo} className={`${baseClassName}__logo`} />
        {name}
        {selected && (
          <div className={`${baseClassName}__check`}>
            <WpIcon name="check-circle" />
          </div>
        )}
        {connected && !selected && <span className={`${baseClassName}__right-msg`}>{selectMessage}</span>}
        {connected && selected && connectedMsg && (
          <div className={`${baseClassName}__count`}>
            <WpBadge color="green">{connectedMsg}</WpBadge>
          </div>
        )}
        {!connected && <span className={`${baseClassName}__right-msg`}>Connect</span>}
      </WpContainerBody>
    </WpContainer>
  );
};

export default SourceWrapper;
